module.exports = __webpack_public_path__ + "img/model_55_ug.ad340762.jpg";